import { routerComponents } from './routerComponents';

const customRoutes = [
  {
    name: 'customPageSaugu',
    path: '/saugu/:page?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/saugu/puslapis/saugu',
    },
  },
  {
    name: 'customPageUefaTransliacijos',
    path: '/uefa-transliacijos/:page?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/puslapis/uefa-transliacijos',
    },
  },
  {
    name: 'customPageEurobasket',
    path: '/sportas/eurobasket-2025/:page?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/sportas/puslapis/eurobasket-2025',
    },
  },
  {
    name: 'customPageEuroleague',
    path: '/krepsinis/eurolyga/:page?/:subpage?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/krepsinis/puslapis/eurolyga',
    },
  },
  {
    name: 'customPageDakar',
    path: '/sportas/dakaras/:page?/:subpage?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/sportas/puslapis/dakaras',
    },
  },
];

export default customRoutes;
